class Zendesk {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  get(clientId) {
    return this.apiClient.post('v1/zendesk/jwt', {
      clientId
    }).then(response => response.data);
  }
}

export { Zendesk };
//# sourceMappingURL=Zendesk.js.map
